import { z } from "zod";

// isolatedDeclarations: define output shapes as TS interfaces, annotate
// Zod consts with z.ZodType<Interface> so tsc can emit declarations without
// reading across module boundaries (D-15 paranoid-strict tsconfig).
//
// exactOptionalPropertyTypes: interface optional fields must use `number | undefined`
// (not just `number?`) to match ZodOptional's output type `T | undefined`.

export interface Ingredient {
  name: string;
  quantity?: number | undefined;
  unit?: string | undefined;
  note?: string | undefined;
}

export const Ingredient: z.ZodType<Ingredient> = z.strictObject({
  name: z.string().min(1).max(200),
  quantity: z.number().positive().optional(),
  unit: z.string().min(1).max(50).optional(),
  note: z.string().min(1).max(500).optional(), // optional free-form note (e.g., "freshly cracked")
});

export interface IngredientGroup {
  label: string; // free-form per recipe (META-04)
  items: Ingredient[];
}

export const IngredientGroup: z.ZodType<IngredientGroup> = z.strictObject({
  label: z.string().min(1).max(100), // free-form per recipe (META-04)
  items: z.array(Ingredient).min(1),
});
